module.exports = __webpack_public_path__ + "img/data-py.139b9365.png";